import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, Link } from 'react-router-dom';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import * as XLSX from 'xlsx';

const StockReport = () => {
    const location = useLocation();

    const months = [
        { value: 1, label: 'January' },
        { value: 2, label: 'February' },
        { value: 3, label: 'March' },
        { value: 4, label: 'April' },
        { value: 5, label: 'May' },
        { value: 6, label: 'June' },
        { value: 7, label: 'July' },
        { value: 8, label: 'August' },
        { value: 9, label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' },
    ];

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;  
    const currentYear = currentDate.getFullYear();

    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedDate, setSelectedDate] = useState('');

    const firstDayOfMonth = `${currentYear}-${String(selectedMonth).padStart(2, '0')}-01`;  
    const lastDayOfMonth = `${currentYear}-${String(selectedMonth).padStart(2, '0')}-${new Date(currentYear, selectedMonth, 0).getDate()}`;
    
    const [fromDate, setFromDate] = useState(firstDayOfMonth);  
    const [toDate, setToDate] = useState(lastDayOfMonth);
    const [getData, setGetData] = useState([]);
    console.log("getdata",getData)

    useEffect(() => {
        const getdata = async () => {
            try {
                const response = await axios.get('https://api.trucoo.in/invoice/invoice/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-API-KEY': 'erpTrucoo'
                    }
                });

                if (response.data.status === 'success') {
                    setGetData(response.data.data || []);
                }
            } catch (error) {
                console.error("Error:", error.response || error.message);
            }
        };

        getdata();
    }, []); 

    const handleDateChange = (e) => {
        const date = e.target.value;
        setSelectedDate(date);
        setFromDate(date);
        setToDate(date);
    };

    const filteredData = Array.isArray(getData)
        ? getData.filter((order) => {
            // const orderDate = new Date(order.date).toISOString().split('T')[0];
            const orderDateObj = new Date(order.date);
            const orderDate = `${orderDateObj.getFullYear()}-${String(orderDateObj.getMonth() + 1).padStart(2, '0')}-${String(orderDateObj.getDate()).padStart(2, '0')}`;

            const isInDateRange = 
                (fromDate === "" || orderDate >= fromDate) && 
                (toDate === "" || orderDate <= toDate);

            return isInDateRange;
        })
        : [];

    const groupedData = filteredData.flatMap(order => 
        order.orderData.map(item => ({
            ...item,
            qty: parseFloat(item.qty),
            itemWeight: parseFloat(item.itemWeight),
            itemPrice: parseFloat(item.itemPrice),
            itemGst: parseFloat(item.itemGst)
        }))
    ).reduce((acc, item) => {
        const existingItem = acc.find(i => i.itemCode === item.itemCode);
        if (existingItem) {
            existingItem.qty += item.qty;
            existingItem.amount += (item.qty * (item.itemPrice - (item.itemPrice * item.itemGst / 100)));
            existingItem.liters += (item.qty * item.itemWeight) / 1000;
        } else {
            acc.push({
                ...item,
                amount: item.qty * (item.itemPrice - (item.itemPrice * item.itemGst / 100)),
                liters: (item.qty * item.itemWeight) / 1000
            });
        }
        return acc;
    }, []);

    let totalQuantity = 0;
    let totalAmountAcc = 0;
    let totalCGST = 0;
    let totalSGST = 0;
    let grandTotal = 0;
    let totalLiters = 0;
    let totalDicount = 0;

    const downloadExcel = () => {
        const ws = XLSX.utils.table_to_sheet(document.getElementById('printableArea')); 
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Invoice Data');
        XLSX.writeFile(wb, 'Monthly_Stock_Report.xlsx');
    };

    const handleMonthChange = (e) => {
        const month = e.target.value;
        setSelectedMonth(month);
        const updatedFromDate = `${currentYear}-${String(month).padStart(2, '0')}-01`;
        const updatedToDate = `${currentYear}-${String(month).padStart(2, '0')}-${new Date(currentYear, month, 0).getDate()}`;
        setFromDate(updatedFromDate);
        setToDate(updatedToDate);
        setSelectedDate('');
    };

    function customRound(num) {
        const decimalPart = num % 1;
        if (decimalPart < 0.5) {
          return Math.floor(num) + 0.5;
        } else {
          return Math.ceil(num);
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">Invoice</h4>
                                <p className="mb-0 box-subtitle">Monthly Stock Report</p>
                            </div>
                            <div className="box-body">
                                <div className="row"> 
                                    <div className="col-lg-3 mb-4">
                                        <select
                                            value={selectedMonth}
                                            onChange={handleMonthChange}
                                            className="border p-2"
                                        >
                                            {months.map((month) => (
                                                <option key={month.value} value={month.value}>
                                                    {month.label}
                                                </option>
                                            ))}
                                        </select>
                                        
                                        <input
                                            type="date"
                                            value={selectedDate}
                                            onChange={handleDateChange}
                                            className="border p-2 ml-2"
                                        />
                                    </div>
                                    <div className="col-lg-9 mb-4" align="right">
                                        <button onClick={downloadExcel} className="btn btn-primary"> Download Excel </button>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="table-responsive">
                                        {filteredData?.length > 0 ?
					                        <table id="printableArea" className="table text-fade table-bordered table-hover display nowrap margin-top-10 w-p100">
                                                <thead>
                                                    <tr className="fs-10 fw-600 text-dark">
                                                        <th rowspan="2">S.No</th>
                                                        <th rowspan="2">PARTICULARS</th>
                                                        <th rowspan="2">UNIT</th>
                                                        <th rowspan="2">GRADES</th>
                                                        <th rowspan="2">QTY</th>
                                                        <th rowspan="2">LTR</th>
                                                        <th rowspan="2">RATE</th>
                                                        <th rowspan="2">AMOUNT</th>
                                                        <th colspan="2">CGST</th>   
                                                        <th colspan="2">SGST</th>
                                                        <th rowspan="2">Discount</th>
                                                        <th rowspan="2">Total Amount</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {groupedData.map((item, index) => {
                                                        const price = item.itemPrice;
                                                        const gst = item.itemGst;

                                                        const productGst = price * (gst / 100);
                                                        const productPrice = price - productGst;
                                                        const amount = productPrice * item.qty;
                                                        const cgstValue = (productGst / 2) * item.qty;
                                                        const sgstValue = (productGst / 2) * item.qty;
                                                        const totalAmount = price * item.qty;

                                                        let discount = 0;
                                                        if(item.discountType && item.discountType === 'grade'){
                                                            const grade =customRound((parseFloat(item.qty) * parseFloat(item.itemWeight) / 1000) / parseFloat(item.itemGrade))
                                                            discount = parseFloat(item.discountValue) * grade
                                                        }
                                                        if(item.discountType &&  item.discountType === 'percent'){
                                                            const total = parseFloat(item.qty) * parseFloat(item.itemPrice);
                                                            discount = total*(parseFloat(item.discountValue)/100)
                                                        }
                                                        if(item.discountType &&  item.discountType === 'liters'){
                                                            const litters = parseFloat(item.qty) * (parseFloat(item.itemWeight)/1000)
                                                            discount = litters * item.discountValue
                                                        }

                                                        totalQuantity += item.qty;
                                                        totalAmountAcc += amount;
                                                        totalCGST += cgstValue;
                                                        totalSGST += sgstValue;
                                                        grandTotal += totalAmount - discount;
                                                        totalLiters += item.liters;
                                                        totalDicount += discount;

                                                        return (
                                                            <tr key={index} className="fw-400 text-gray-600 fs-12">
                                                                <td>{index + 1}</td>
                                                                <td className="text-left">{item.itemName}</td>
                                                                <td>{item.itemUnit}</td>
                                                                <td>{item.itemGrade}</td>
                                                                <td>{parseFloat(item.qty).toFixed(2)}</td>
                                                                <td>{item.liters.toFixed(2)}</td>
                                                                <td>{productPrice.toFixed(2)}</td>
                                                                <td>{(productPrice * item.qty).toFixed(2)}</td>
                                                                <td>{(gst / 2).toFixed(1)}%</td>
                                                                <td>{((productGst / 2) * item.qty).toFixed(2)}</td>
                                                                <td>{(gst / 2).toFixed(1)}%</td>
                                                                <td>{((productGst / 2) * item.qty).toFixed(2)}</td>
                                                                <td className="text-end">{parseFloat(discount).toFixed(2)}</td>
                                                                <td className="text-end">{(totalAmount - parseFloat(discount)).toFixed(2)}</td>
                                                            </tr>
                                                        );
                                                    })}
                                                    <tr className="fw-600 text-dark">
                                                        <td colSpan="4" className="text-center">TOTAL</td>
                                                        <td>{parseFloat(totalQuantity).toFixed(2)}</td>
                                                        <td>{totalLiters.toFixed(2)}</td>
                                                        <td></td>
                                                        <td>{totalAmountAcc.toFixed(2)}</td>
                                                        <td></td>
                                                        <td>{totalCGST.toFixed(2)}</td>
                                                        <td></td>
                                                        <td>{totalSGST.toFixed(2)}</td>
                                                        <td>{totalDicount.toFixed(2)}</td>
                                                        <td className="text-end">{grandTotal.toFixed(2)}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            :
                                            <p className="text-danger" align="center"> No Data Available</p>
                                        }
                                        </div>
                                    </div>

                                </div>
                              
                            </div>
                        </div>
                    </section>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default StockReport;